
import Experience from './experience/experience.js'

const experience = new Experience(document.querySelector('canvas.webgl'))